<template>
  <div id="dining" v-if="$store.state.diningOptions">
    <h1 class="mt-2">Dining</h1>

    <!-- CHOOSE A LOCATION -->
    <div
      v-if="view === 'locations'"
      class="row"
    >
      <div
        v-for="(location, index) in $store.state.diningOptions"
        class="col-sm-4"
      >
        <div class="card">
          <!-- <img class="card-img-top" :src="location.imageUrl"> -->
          <div class="card-body">
            <h5>{{ location.properties.name }}</h5>
            <button
              @click="launchLocation(index)"
              class="btn btn-outline-dark"
            >
              <i class="fas fa-utensils"></i> View Location
            </button>
          </div><!-- /.card-body -->
        </div><!-- /.card -->
      </div><!-- /.col-sm-4 -->
    </div><!-- /.row -->

    <!-- LOAD LOCATION MENUS AND DAYS OF THE WEEK -->
    <div
      v-if="view === 'menus'"
    >
      <button
        class="nav-link btn btn-outline-light mr-2"
        @click="view = 'locations'"
      ><i class="fas fa-arrow-left"></i> Back to Locations</button>
      <h2>{{ $store.state.diningOptions[currentLocation].properties.name }}</h2>
      <ul class="nav nav-pills mb-2">
        <li class="nav-item">
          <button
            class="nav-link btn btn-outline-light mr-2"
            :class="{ active: currentDay === 0 }"
            @click="currentDay = 0"
          >Sun</button>
        </li>
        <li class="nav-item">
          <button
            class="nav-link btn btn-outline-light mr-2"
            :class="{ active: currentDay === 1 }"
            @click="currentDay = 1"
          >Mon</button>
        </li>
        <li class="nav-item">
          <button
            class="nav-link btn btn-outline-light mr-2"
            :class="{ active: currentDay === 2 }"
            @click="currentDay = 2"
          >Tue</button>
        </li>
        <li class="nav-item">
          <button
            class="nav-link btn btn-outline-light mr-2"
            :class="{ active: currentDay === 3 }"
            @click="currentDay = 3"
          >Wed</button>
        </li>
        <li class="nav-item">
          <button
            class="nav-link btn btn-outline-light mr-2"
            :class="{ active: currentDay === 4 }"
            @click="currentDay = 4"
          >Thu</button>
        </li>
        <li class="nav-item">
          <button
            class="nav-link btn btn-outline-light mr-2"
            :class="{ active: currentDay === 5 }"
            @click="currentDay = 5"
          >Fri</button>
        </li>
        <li class="nav-item">
          <button
            class="nav-link btn btn-outline-light mr-2"
            :class="{ active: currentDay === 6 }"
            @click="currentDay = 6"
          >Sat</button>
        </li>
      </ul>

      <!-- DISPLAY MEALS -->
      <div class="meals">
        <b-card
          v-for="(meal, index) in $store.state.diningOptions[currentLocation].properties.diningOptions.days[currentDay].menus"
          v-bind:key="index"
          no-body
          class="mb-1"
        >
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block href="#" v-b-toggle="'accordion-' + index" variant="outline-light">{{ meal.title }} <small>{{ meal.startTime | toTime }}</small></b-button>
          </b-card-header>
          <b-collapse :id="'accordion-' + index" accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <!-- <p class="meal-icon" v-html="meal.icon"></p> -->
              <!-- Meal Times -->
              <h3><span v-if="meal.startTime">{{ meal.startTime | toTime }}</span><span v-if="meal.endTime"> - {{ meal.endTime | toTime }}</span></h3>
              <!-- Meal Description -->
              <div v-html="meal.body"></div>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div><!-- /.meals -->
    </div><!-- /v-if view === 'menus' -->
  </div><!-- /#dining -->
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'

export default {
  computed: {
    ...mapState([
      'dashboard'
    ])
  },
  created() {
    this.currentDay = new Date().getDay()
  },
  methods: {
    launchLocation(index) {
      this.currentLocation = index
      this.view = 'menus'
      this.currentDay = new Date().getDay()
    }
  },
  data() {
    return {
      view: 'locations',
      currentLocation: 0,
      currentDay: 0
    }
  },
  filters: {
    // toTime(value) {
    //   let time = new Date(value.seconds * 1000)
    //   return moment(time).format('h:mm a')
    // }
    toTime (value) {
      let hoursFormatted
      let amPm
      const hours = parseInt(value.substr(0, 2), 10)
      const minutes = value.substr(3, 2)
      if (hours < 13) {
        hoursFormatted = hours
        amPm = 'a.m.'
      } else {
        hoursFormatted = hours - 12
        amPm = 'p.m.'
      }
      return hoursFormatted + ':' + minutes + ' ' + amPm
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Dining.vue